(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3784],{

/***/ 32512:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/block-website",
      function () {
        return __webpack_require__(47702);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 47702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90948);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19630);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95629);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34745);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26771);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74743);













// 自定义隐藏滚动条且保留滚动特性(div
const ScrollDiv = (0,_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
// 自定义滚动条(ul
const ScrollUlShow = (0,_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)("ul")({
    "-msOverflowStyle": "none",
    /* 适用于 IE 和 Edge */ scrollbarWidth: "thin",
    /* 适用于 Firefox，设置滚动条为细 */ "&::-webkit-scrollbar": {
        width: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        /* 设置滚动条滑块的颜色 */ borderRadius: "10px"
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1"
    },
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const BlockWebsites = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    const [allData, setAllData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [showData, setShowData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 展示的数据
    ;
    const [allHistory, setAllHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [showHistory, setShowHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [ruleValue, setRuleValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") // 输入的规则值
    ;
    const [ruleFlag, setRuleFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 输入框是否为空
    ;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 移动端是否展示输入框
    ;
    const [isOpenHistory, setIsOpenHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否展开显示浏览器记录
    ;
    const [searchValue, setSearchValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const leftRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) //正在加载获取数据
    ;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (leftRef.current) {
            setHeight(leftRef.current.offsetHeight) // 获取高度
            ;
        }
    }, [
        isOpen
    ]);
    // 分页参数
    const [pagination, setPagination] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        reqNum: 100,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    const mergeUniqueByUrl = (old, next)=>Array.from(new Map([
            ...old,
            ...next
        ].map((item)=>[
                item.url,
                item
            ])).values());
    // 获取浏览器记录数据
    const getHistoryData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async function(nowOffset, deviceUdid) {
        let { isCurrent , replace =false  } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        const response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .getLocalAndroidAll */ .gH)({
            username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__/* .readUserEmail */ .t)(),
            params: {
                category: "CHROME_HISTORY",
                offset: nowOffset,
                limit: pagination.reqNum,
                deviceUdid
            }
        });
        if (isCurrent && !isCurrent()) return;
        if (response.data.contents == null) {
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            return;
        }
        const contents = response.data.contents;
        setAllHistory((old)=>mergeUniqueByUrl(replace ? [] : old, contents));
        setShowHistory((old)=>mergeUniqueByUrl(replace ? [] : old, contents));
    }, [
        pagination.reqNum
    ]);
    const loadBlockedSites = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async function(deviceUdid) {
        let { isCurrent  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_5__/* .setBlock */ .sk)({
            device_id: deviceUdid
        });
        if (isCurrent && !isCurrent()) return;
        const newBlockData = result.data.website;
        setAllData(newBlockData.map((item)=>({
                name: item
            })));
        setShowData(newBlockData.map((item)=>({
                name: item
            })));
        setIsLoading(false);
    }, []);
    const reloadPageData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async function(deviceUdid) {
        let { signal , isCurrent  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        setIsLoading(true);
        setAllData([]);
        setShowData([]);
        setAllHistory([]);
        setShowHistory([]);
        setRuleValue("");
        setSearchValue("");
        setPagination({
            reqNum: 100,
            nowOffset: 0,
            maxNum: false
        });
        await Promise.all([
            loadBlockedSites(deviceUdid, {
                isCurrent
            }),
            getHistoryData(0, deviceUdid, {
                isCurrent,
                replace: true
            })
        ]);
    }, [
        getHistoryData,
        loadBlockedSites
    ]);
    // 设备切换时重置屏蔽站点与操作历史
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_9__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((_, scope)=>{
        const deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__/* .readLocalDeviceUdid */ .S)(scope.context);
        if (!deviceUdid) return;
        reloadPageData(deviceUdid, scope);
    }, [
        reloadPageData
    ]));
    const isBlock = async (param)=>{
        let { name , action  } = param;
        const deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__/* .readLocalDeviceUdid */ .S)();
        const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_5__/* .setBlock */ .sk)({
            device_id: deviceUdid,
            type: "website",
            name,
            action
        });
        await (0,src_api_android__WEBPACK_IMPORTED_MODULE_5__/* .androidLocalRefresh */ .DF)({
            device_id: deviceUdid,
            type: 51,
            limit: action,
            url: name
        });
        const newBlockData = result.data.website;
        setAllData(newBlockData.map((item)=>({
                name: item
            })));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const results = allData.filter((item)=>{
            return item.name.toLowerCase().includes(searchValue.toLowerCase());
        });
        setShowData(results);
    }, [
        searchValue,
        allData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const results = allHistory.filter((item)=>{
            return item.url.toLowerCase().includes(ruleValue.toLowerCase());
        });
        setShowHistory(results);
    }, [
        ruleValue,
        allHistory
    ]);
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 滚动百分比
    ;
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 95) {
            const nowOffset = pagination.nowOffset + pagination.reqNum;
            setPagination((page)=>({
                    ...page,
                    nowOffset
                }));
            if (!pagination.maxNum) {
                getHistoryData(nowOffset, (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__/* .readLocalDeviceUdid */ .S)());
            }
        }
    }, [
        scroll,
        getHistoryData,
        pagination.maxNum,
        pagination.nowOffset,
        pagination.reqNum
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Block Website");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 埋点上报
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (allData.length === 0) return;
        const events = allData.map((item)=>{
            return {
                event_name: "Click_Block",
                properties: {
                    limit: (item === null || item === void 0 ? void 0 : item.name) || ""
                }
            };
        });
        if (events.length > 0) {}
    }, [
        allData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollDiv, {
            className: "w-full !h-[calc(var(--vh2)*100-215px)] smj:!h-[calc(var(--vh2)*100-90px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] overflow-auto bg-white font-[Poppins] relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-full flex smj:flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full h-auto smjs:p-[36px_30px_0px_30px] smj:px-[16px] smjs:[border-right:1px_solid_#DCDCDC] smjs:max-w-[520px]",
                        ref: leftRef,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full smjs:h-[206px] flex flex-col smjs:justify-start items-center px-[30px] smj:px-[16px] [border:1px_solid_#DCDCDC] rounded-[8px] smj:mt-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex justify-between items-center w-full smjs:mt-[24px] mt-[8px] mb-[18px] smj:mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[16px] smjs:text-[#000000] smj:text-[#666CFF] font-[600] leading-[24px]",
                                                children: t("Add Rule")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: isOpen ? "/image/website/less.svg" : "/image/website/more.svg",
                                                width: 16,
                                                height: 16,
                                                alt: "",
                                                className: "smjs:hidden cursor-pointer",
                                                onClick: ()=>{
                                                    setIsOpen(!isOpen);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                id: "ruleAddress",
                                                type: "text",
                                                placeholder: t("Enter website address"),
                                                value: ruleValue,
                                                className: "w-full h-[40px] smj:h-[36px] bg-[#F4F5F6] rounded-[8px] outline-none relative ".concat(isOpen || "smj:hidden", "\n                            ").concat(ruleFlag === 1 ? "shadow-[inset_0px_0px_0px_1px_red] placeholder:text-red-500 caret-red-500" : "focus:shadow-[inset_0px_0px_0px_1px_#666CFF] caret-[#666CFF]", "\n                            px-[18px] smj:px-[13px] text-[12px] text-[#222222] placeholder:text-[#9E9E9E] leading-[21px] smj:leading-[18px]"),
                                                onChange: (e)=>{
                                                    if (e.target.value.trim() !== "") setRuleFlag(0);
                                                    setRuleValue(e.target.value);
                                                },
                                                onFocus: ()=>setIsOpenHistory(true),
                                                onBlur: ()=>setIsOpenHistory(false)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute top-11 smj:top-10 z-[10] w-full bg-white rounded-[6px] shadow-[0px_0px_3px_0px_#0000001A] p-[4px_18px_0px_18px] smj:p-[4px_12px_0px_12px] smjs:!max-h-[200px] overflow-auto ".concat(isOpenHistory || "hidden", " ").concat(showHistory.length > 0 || "!p-0"),
                                                style: {
                                                    maxHeight: "calc(".concat(height, "px - 102px)")
                                                },
                                                ref: dom,
                                                children: showHistory.map((item, i)=>{
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "py-1 text-[12px] text-[#222222CC] leading-[24px] line-clamp-1 overflow-hidden border-b-[1px] border-[#2222221A] cursor-pointer",
                                                        onMouseDown: ()=>setRuleValue(item.url),
                                                        children: item.url
                                                    }, i);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "w-[180px] h-[40px] smj:w-[100px] smj:h-[35px] text-[12px] text-[#000000] font-[600] leading-[18px] bg-[#FFCF55] rounded-[30px] my-[30px] smj:m-[16px_0_13px_auto] ".concat(isOpen || "smj:hidden"),
                                        onClick: ()=>{
                                            if (ruleValue === "" || allData.some((item)=>item.name === ruleValue)) {
                                                document.getElementById("ruleAddress").focus();
                                                setRuleFlag(1);
                                            } else {
                                                isBlock({
                                                    name: ruleValue,
                                                    action: true
                                                });
                                            }
                                        },
                                        children: t("Block")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-[12px] text-[#9E9E9E] font-[400] leading-[18px] smjs:hidden mb-4 ".concat(isOpen || "smj:hidden"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    t("Tips"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "1. ",
                                                    t("You can block a single page or an entire website")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "2. ",
                                                    t("Blocking an address will also block all pages under it e")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-[12px] text-[#9E9E9E] font-[400] leading-[18px] smj:hidden mt-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            t("Tips"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "1. ",
                                            t("You can block a single page or an entire website")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "2. ",
                                            t("Blocking an address will also block all pages under it e")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full p-[36px_30px_0px_30px] smj:p-[24px_16px_0px_16px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex smjs:justify-between smj:flex-col smjs:items-center mb-[12px] smj:mb-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-[16px] text-[#000000] font-[600] leading-[24px] smj:mb-[10px]",
                                        children: t("Blocked Sites")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative h-[36px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                className: "w-[280px] smj:w-full text-[14px] leading-[20px] placeholder:text-[#9E9E9E] text-[#222222] bg-[#F4F5F6] border-[1px] border-[#F4F5F6] focus:border-[#666CFF] focus:outline-none rounded-[8px] font-[400] pl-4 pr-10 py-2",
                                                placeholder: t("Search"),
                                                onInput: (e)=>{
                                                    setSearchValue(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute top-0 right-0 flex items-center h-full pr-4",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: "/search.svg",
                                                    className: "w-[20px] h-[20px]",
                                                    width: 20,
                                                    height: 20,
                                                    alt: "Search"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollUlShow, {
                                className: "w-full smjs:!max-h-[666px] overflow-auto",
                                style: {
                                    maxHeight: "calc(var(--vh2) * 100 - 190px - ".concat(height, "px)")
                                },
                                children: showData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        i: true,
                                        className: "text-[16px] text-[#000000] font-[400] leading-[24px] break-all [border-bottom:1px_solid_#E5E7EB]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-center py-[18px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "max-w-[78%] flex items-center gap-x-[12px] smj:gap-x-[10px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            src: "/websites.svg",
                                                            alt: "",
                                                            width: 24,
                                                            height: 24,
                                                            className: "w-[24px] h-[24px]"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: item.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    className: "w-auto p-[4px_11px_4px_11px] text-[12px] text-[#000000] font-[400] leading-[18px] bg-[#FFCF55] rounded-[15px]",
                                                    onClick: ()=>isBlock({
                                                            name: item.name,
                                                            action: false
                                                        }),
                                                    children: t("Unblock")
                                                })
                                            ]
                                        })
                                    }, index))
                            }),
                            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                            }) : null,
                            allData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[#222222E5] text-[15px] mt-2",
                                children: t("No websites have been blocked yet")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlockWebsites);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1664,9774,2888,179], function() { return __webpack_exec__(32512); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);